import { CART_RECEIVE, CART_SHOW_INFO, CART_HINT_CART } from '../constants';

export const cart = (
    state = { quantity: 0, orderTotal: 0, showInfo: false, hintCart: false, selectedCombinedConfiguratorKeys: [] },
    action
) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_INFO:
        case CART_HINT_CART:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
